var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _c(
                "div",
                { staticClass: "table-page-search-wrapper" },
                [
                  _c(
                    "a-form",
                    { attrs: { layout: "inline" } },
                    [
                      _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 8, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "所属门店",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      attrs: { placeholder: "请选择门店" },
                                      on: { change: _vm.onStoreChange },
                                      model: {
                                        value: _vm.storeId,
                                        callback: function ($$v) {
                                          _vm.storeId = $$v
                                        },
                                        expression: "storeId",
                                      },
                                    },
                                    _vm._l(_vm.storeOptionList, function (s) {
                                      return _c(
                                        "a-select-option",
                                        { key: s.id, attrs: { value: s.id } },
                                        [_vm._v(_vm._s(s.name))]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-tabs",
                {
                  model: {
                    value: _vm.activeTab,
                    callback: function ($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab",
                  },
                },
                [
                  _c(
                    "a-tab-pane",
                    { key: "table", attrs: { tab: "桌台管理" } },
                    [
                      _c(
                        "div",
                        { staticClass: "table-page-search-wrapper" },
                        [
                          _c(
                            "a-form",
                            {
                              attrs: { layout: "inline" },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return _vm.searchQuery.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c(
                                "a-row",
                                { attrs: { gutter: 24 } },
                                [
                                  _c(
                                    "a-col",
                                    { attrs: { md: 6, sm: 24 } },
                                    [
                                      _c(
                                        "a-form-item",
                                        {
                                          attrs: {
                                            label: "区域",
                                            labelCol: _vm.labelCol,
                                            wrapperCol: _vm.wrapperCol,
                                          },
                                        },
                                        [
                                          _c(
                                            "a-select",
                                            {
                                              attrs: {
                                                placeholder: "全部区域",
                                                "allow-clear": "",
                                              },
                                              model: {
                                                value: _vm.queryParam.areaId,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryParam,
                                                    "areaId",
                                                    $$v
                                                  )
                                                },
                                                expression: "queryParam.areaId",
                                              },
                                            },
                                            _vm._l(_vm.areas, function (a) {
                                              return _c(
                                                "a-select-option",
                                                {
                                                  key: a.id,
                                                  attrs: { value: a.id },
                                                },
                                                [_vm._v(_vm._s(a.name))]
                                              )
                                            }),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-col",
                                    { attrs: { md: 6, sm: 24 } },
                                    [
                                      _c(
                                        "a-form-item",
                                        {
                                          attrs: {
                                            label: "状态",
                                            labelCol: _vm.labelCol,
                                            wrapperCol: _vm.wrapperCol,
                                          },
                                        },
                                        [
                                          _c(
                                            "a-select",
                                            {
                                              attrs: {
                                                placeholder: "全部状态",
                                                "allow-clear": "",
                                              },
                                              model: {
                                                value: _vm.queryParam.status,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryParam,
                                                    "status",
                                                    $$v
                                                  )
                                                },
                                                expression: "queryParam.status",
                                              },
                                            },
                                            [
                                              _c(
                                                "a-select-option",
                                                { attrs: { value: "idle" } },
                                                [_vm._v("空闲")]
                                              ),
                                              _c(
                                                "a-select-option",
                                                {
                                                  attrs: { value: "occupied" },
                                                },
                                                [_vm._v("占用")]
                                              ),
                                              _c(
                                                "a-select-option",
                                                {
                                                  attrs: { value: "reserved" },
                                                },
                                                [_vm._v("预定")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-col",
                                    { attrs: { md: 12, sm: 24 } },
                                    [
                                      _c(
                                        "a-button",
                                        {
                                          attrs: { type: "primary" },
                                          on: { click: _vm.searchQuery },
                                        },
                                        [_vm._v("查询")]
                                      ),
                                      _c(
                                        "a-button",
                                        {
                                          staticStyle: { "margin-left": "8px" },
                                          on: { click: _vm.searchReset },
                                        },
                                        [_vm._v("重置")]
                                      ),
                                      _vm.btnEnableList.indexOf(1) > -1
                                        ? _c(
                                            "a-button",
                                            {
                                              staticStyle: {
                                                "margin-left": "8px",
                                              },
                                              attrs: {
                                                type: "primary",
                                                icon: "plus",
                                              },
                                              on: { click: _vm.handleTableAdd },
                                            },
                                            [_vm._v("新增桌台")]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "a-button",
                                        {
                                          staticStyle: { "margin-left": "8px" },
                                          attrs: { icon: "printer" },
                                          on: { click: _vm.handlePrint },
                                        },
                                        [_vm._v("打印桌码")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("a-table", {
                        attrs: {
                          size: "middle",
                          bordered: "",
                          rowKey: "id",
                          columns: _vm.columns,
                          dataSource: _vm.dataSource,
                          scroll: _vm.scroll,
                          loading: _vm.loading,
                          pagination: false,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "action",
                            fn: function (text, record) {
                              return _c(
                                "span",
                                {},
                                [
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleTableEdit(record)
                                        },
                                      },
                                    },
                                    [_vm._v("编辑")]
                                  ),
                                  _c("a-divider", {
                                    attrs: { type: "vertical" },
                                  }),
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleTableQr(record)
                                        },
                                      },
                                    },
                                    [_vm._v("桌码")]
                                  ),
                                  _c("a-divider", {
                                    attrs: { type: "vertical" },
                                  }),
                                  _vm.btnEnableList.indexOf(1) > -1
                                    ? _c(
                                        "a",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleTableDelete(
                                                record
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            },
                          },
                          {
                            key: "statusSlot",
                            fn: function (text) {
                              return [
                                _c(
                                  "a-tag",
                                  {
                                    attrs: {
                                      color: _vm.statusColor[text] || "blue",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.statusText[text] || text))]
                                ),
                              ]
                            },
                          },
                          {
                            key: "orderSlot",
                            fn: function (text) {
                              return [
                                text
                                  ? _c("span", [_vm._v(_vm._s(text))])
                                  : _c("span", [_vm._v("-")]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-tab-pane",
                    { key: "area", attrs: { tab: "区域管理" } },
                    [
                      _c(
                        "div",
                        { staticClass: "table-operator" },
                        [
                          _vm.btnEnableList.indexOf(1) > -1
                            ? _c(
                                "a-button",
                                {
                                  attrs: { type: "primary", icon: "plus" },
                                  on: { click: _vm.handleAreaAdd },
                                },
                                [_vm._v("新增区域")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c("a-table", {
                        attrs: {
                          size: "middle",
                          bordered: "",
                          rowKey: "id",
                          columns: _vm.areaColumns,
                          dataSource: _vm.areas,
                          pagination: false,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "areaAction",
                            fn: function (text, record) {
                              return _c(
                                "span",
                                {},
                                [
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleAreaEdit(record)
                                        },
                                      },
                                    },
                                    [_vm._v("编辑")]
                                  ),
                                  _c("a-divider", {
                                    attrs: { type: "vertical" },
                                  }),
                                  _vm.btnEnableList.indexOf(1) > -1
                                    ? _c(
                                        "a",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleAreaDelete(
                                                record
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-tab-pane",
                    { key: "type", attrs: { tab: "桌型管理" } },
                    [
                      _c(
                        "div",
                        { staticClass: "table-operator" },
                        [
                          _vm.btnEnableList.indexOf(1) > -1
                            ? _c(
                                "a-button",
                                {
                                  attrs: { type: "primary", icon: "plus" },
                                  on: { click: _vm.handleTypeAdd },
                                },
                                [_vm._v("新增桌型")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c("a-table", {
                        attrs: {
                          size: "middle",
                          bordered: "",
                          rowKey: "id",
                          columns: _vm.typeColumns,
                          dataSource: _vm.types,
                          pagination: false,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "typeAction",
                            fn: function (text, record) {
                              return _c(
                                "span",
                                {},
                                [
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleTypeEdit(record)
                                        },
                                      },
                                    },
                                    [_vm._v("编辑")]
                                  ),
                                  _c("a-divider", {
                                    attrs: { type: "vertical" },
                                  }),
                                  _vm.btnEnableList.indexOf(1) > -1
                                    ? _c(
                                        "a",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleTypeDelete(
                                                record
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("area-modal", {
                ref: "areaModal",
                attrs: { "store-id": _vm.storeId },
                on: { ok: _vm.loadData },
              }),
              _c("table-type-modal", {
                ref: "typeModal",
                attrs: { "store-id": _vm.storeId },
                on: { ok: _vm.loadData },
              }),
              _c("table-modal", {
                ref: "tableModal",
                attrs: {
                  "store-id": _vm.storeId,
                  areas: _vm.areas,
                  types: _vm.types,
                },
                on: { ok: _vm.loadData },
              }),
              _c("table-qr-modal", { ref: "qrModal" }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }